import { MapPin, Phone, Mail, Clock } from "lucide-react";
import { CONTATO } from "../data/cabanas";

export const Contato = () => (
  <section id="contato" className="py-24 bg-[#faf7f2]" data-testid="contato-section">
    <div className="max-w-7xl mx-auto px-4 sm:px-6 grid lg:grid-cols-2 gap-12 items-start">
      <div>
        <p className="text-[#b85d39] text-xs uppercase tracking-[0.3em] font-bold mb-3">
          Fale com a gente
        </p>
        <h2 className="text-2xl sm:text-3xl lg:text-4xl font-bold text-[#1b4332] mb-8">
          Contato & Localização
        </h2>
        <div className="flex flex-col gap-5">
          <div className="flex items-start gap-4">
            <div className="h-11 w-11 rounded-full bg-[#2d5a27]/10 flex items-center justify-center shrink-0">
              <MapPin className="h-5 w-5 text-[#2d5a27]" />
            </div>
            <div>
              <p className="text-xs uppercase tracking-wider font-bold text-[#526559]">Endereço</p>
              <p className="text-sm text-[#1e2923] mt-1">{CONTATO.endereco}</p>
            </div>
          </div>
          <div className="flex items-start gap-4">
            <div className="h-11 w-11 rounded-full bg-[#2d5a27]/10 flex items-center justify-center shrink-0">
              <Phone className="h-5 w-5 text-[#2d5a27]" />
            </div>
            <div>
              <p className="text-xs uppercase tracking-wider font-bold text-[#526559]">Telefone / WhatsApp</p>
              <a
                href={`https://wa.me/${CONTATO.whatsappLink}`}
                target="_blank"
                rel="noopener noreferrer"
                data-testid="contato-whatsapp-link"
                className="text-sm font-bold text-[#b85d39] mt-1 inline-block hover:underline"
              >
                {CONTATO.whatsapp}
              </a>
            </div>
          </div>
          <div className="flex items-start gap-4">
            <div className="h-11 w-11 rounded-full bg-[#2d5a27]/10 flex items-center justify-center shrink-0">
              <Mail className="h-5 w-5 text-[#2d5a27]" />
            </div>
            <div>
              <p className="text-xs uppercase tracking-wider font-bold text-[#526559]">E-mail</p>
              <a
                href={`mailto:${CONTATO.email}`}
                data-testid="contato-email-link"
                className="text-sm font-bold text-[#b85d39] mt-1 inline-block hover:underline"
              >
                {CONTATO.email}
              </a>
            </div>
          </div>
          <div className="flex items-start gap-4">
            <div className="h-11 w-11 rounded-full bg-[#2d5a27]/10 flex items-center justify-center shrink-0">
              <Clock className="h-5 w-5 text-[#2d5a27]" />
            </div>
            <div>
              <p className="text-xs uppercase tracking-wider font-bold text-[#526559]">Horários</p>
              <p className="text-sm text-[#1e2923] mt-1">
                Check-in a partir das 12h · Check-out até as 16h
              </p>
            </div>
          </div>
        </div>
        <p className="mt-8 text-xs text-[#526559]">CNPJ: {CONTATO.cnpj}</p>
      </div>
      <div className="rounded-2xl overflow-hidden shadow-xl border border-[#e2d9cd] h-[380px]">
        <iframe
          title="Mapa Vila Gramado"
          data-testid="contato-mapa"
          src={`https://www.google.com/maps?q=${encodeURIComponent(CONTATO.endereco)}&output=embed`}
          className="w-full h-full border-0"
          loading="lazy"
        />
      </div>
    </div>
  </section>
);
